<template>
	<div
		class="container-loader"
		:class="{ 'content-loader': background }"
	>
		<div
			class="loading-outer"
			:style="'minHeight: ' + height + 'px'"
		>
			<div
				class="loading"
			>
				<div
					class="loading-spin"
					:class="{ 'loading-spin-white': white }"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		height: {
			type: Number,
			default: 1
		},
		white: {
			type: Boolean,
			default: false
		},
		background: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>

.content-loader {
	z-index: 1;
}
.loading-outer {
	position: relative;
}

.loading {
	width: 44px;
	height: 44px;
	text-align: center;
	line-height: 44px;
	margin: 0;
	font-size: 12px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.loading-spin {
	border: 2px solid transparent;
	font-size: 40px;
	width: 1em;
	height: 1em;
	border-radius: .5em;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	-webkit-animation: spin 1s linear infinite;
	-moz-animation: spin 1s linear infinite;
	animation: spin 1s linear infinite;
	border-top-color: #000;
}

.loading-spin-white {
	border-top-color: #fff;
}

@-webkit-keyframes spin {
	to {
		-webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@-moz-keyframes spin {
	to {
		-webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes spin {
	to {
		-webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
</style>
